import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { util } from './util.js'
Vue.prototype.$util = util

//Vue.config.productionTip = false


Vue.directive('uppercase', {
  bind(el) {
    el.addEventListener('keyup', () => {
      el.value = el.value.toUpperCase();
    })
  }
})

Vue.directive('numericOnly', {
  bind(el) {
    el.addEventListener('keyup', () => {
      let regex = /^[0-9]*$/
      if (!regex.test(el.value)) {
        el.value = el.value.slice(0, -1)
      }
    })
  }
})

Vue.directive('numero', {
  bind(el) {
    el.addEventListener('keyup', (e) => { //console.log('aaa',e.key);
      if (e.key<'0' || e.key>'9') el.value = el.value.slice(0, -1);     
    })
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
